import Config from './Config';
import FocusManagerFacade from './FocusManagerFacade';

const createFocusManager = (options: Partial<Config> = {}): FocusManagerFacade => new FocusManagerFacade(options);

export default createFocusManager;
